<svg width="20" height="20" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
  <path
    d="M10.8357 10.2588C12.9488 14.7904 18.2041 14.5465 14.7003 16.1804C11.1965 17.8142 7.03168 16.2983 5.39784 12.7945C3.764 9.29075 5.27989 5.12589 8.78367 3.49205C12.2874 1.85821 8.7226 5.72728 10.8357 10.2588Z"
    stroke-width="2"
  />
</svg>
